import { FormControlLabel, RadioGroup, Radio as MuiRadio } from '@mui/material'
import cl from 'classnames'
import React, { memo, forwardRef } from 'react'
import { useTranslation } from 'react-i18next'
import { LANGUAGE_ENUM } from '@/shared'
import { getCurrentLanguage } from '@/i18next'
import { FormControlLabelStyled } from './style'

export const Radio = forwardRef(({
																	 options = [],
																	 value,
																	 onChange,
																	 className,
																	 onBlur,
																	 name,
																	 disabled,
													 }, ref) => {
	const { t } = useTranslation()
	const lang = getCurrentLanguage()

	return (
		<RadioGroup
			classes={{
				root: cl(options.length > 2 ? 'flex-column' : 'flex-row', className),
			}}
			value={value}
			onChange={onChange}
			onBlur={onBlur}
			name={name}
			ref={ref}
		>
			{options.map((answer, answerIdx) => {
				const label = {
					[LANGUAGE_ENUM.rus]: answer.nameRu,
					[LANGUAGE_ENUM.kz]: answer.nameKz,
				}
				return (
					<FormControlLabelStyled
						key={answerIdx}
						control={<MuiRadio disabled={disabled}/>}
						label={label[lang]}
						value={answer.code}
						classes={{
							root: cl('m-0'),
						}}
					/>
				)
			})}
		</RadioGroup>
	)
})